<template>
	<div>
		<div class="canpinBox_one" :style="{
			marginBottom: mabot
		}">
			<div class="canpinBox_one_one">{{ title }}</div>
			<div class="canpinBox_one_two" @click="goMore" v-if="more">
				<div>{{ $t("i18n_143") }}</div>
				<div>
					<img src="@/assets/index/yjt.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {

	},
	props: {
		title: {
			typeof: String,
			default: ''
		},
		more: {
			typeof: Boolean,
			default: true
		},
		mabot: {
			typeof: String,
			default: '68px'
		}
	},
	data() {
		return {

		}
	},
	mounted() {

	},
	methods: {
		goMore() {
			this.$emit('goMore')
		}
	}
}
</script>

<style></style>
<style scoped lang="scss">
.canpinBox_one {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 68px;

	.canpinBox_one_one {
		// font-size: 45px;
		font-size: 36px;
		
		font-weight: bold;
		color: #000000;
	}

	.canpinBox_one_two {
		display: flex;
		align-items: center;
		cursor: pointer;

		>div:nth-of-type(1) {
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			margin-right: 20px;
		}

		>div:nth-of-type(2) {
			display: flex;
			align-items: center;

			img {
				width: 8px;
				height: 14px;
				object-fit: contain;
			}
		}
	}
}

@media screen and (max-width:1200px) {
	.canpinBox_one {
		margin-bottom: 30px !important;
		padding: 0 30px;

		.canpinBox_one_one {
			font-size: 24px;
		}
	}
}
</style>